<mat-checkbox
  [formControl]="inputControl"
  [attr.disabled]="disabled"
  [color]="'primary'"
  (change)="emitChange($event)"
>
  <!-- {{ label | translate }} -->
  <div style="white-space: normal" [innerHtml]="label | translate" (click)="onLabelClick()"></div>
</mat-checkbox>
